import { Component, Input } from '@angular/core';

@Component({
  selector: 'ocf-alert',
  template: `
    @switch (type) {
      @case ('warning') {
        <mat-icon>warning</mat-icon>
      }
      @case ('info') {
        <mat-icon>info</mat-icon>
      }
      @case ('success') {
        <mat-icon>check_circle</mat-icon>
      }
      @case ('danger') {
        <mat-icon>error</mat-icon>
      }
    }

    <ng-content></ng-content>
  `,
  styles: [
    `
      :host {
        width: 100%;
        border: 1px solid #fff;
        border-radius: 3px;
        display: flex;
        justify-content: left;
        align-items: center;
      }

      mat-icon {
        min-width: 25px;
        margin: 0.25em 0.5em;
      }

      :host[type='warning'] {
        color: var(--color-warning);
        border-color: var(--color-warning);
      }

      :host[type='danger'] {
        color: var(--color-warning);
        border-color: var(--color-warning);
      }

      :host[type='success'] {
        color: var(--color-success);
        border-color: var(--color-success);
      }

      :host[type='info'] {
        color: var(--color-info);
        border-color: var(--color-info);
      }
    `,
  ],
  standalone: false,
})
export class AlertComponent {
  @Input()
  text: string = '';

  @Input()
  type: 'warning' | 'info' | 'success' | 'danger' = 'info';
}
